import React from 'react';
import { useSelector } from 'react-redux';
import uniqBy from 'lodash/uniqBy';

import { Contact } from '@/types/contact';
import { RootState } from '@/store';
import { ContactView } from '@/components/pages/Subscription/Presentation/Form/Field/Contact/ContactView';

type Props = {
  value?: number;
  error?: string;
  id: string;
  onChange: (contactId: number | undefined, touched: boolean) => void;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  target?: 'billingContactId' | 'contactId';
  setFieldValue?: {
    (
      field:
        | 'billingContactId'
        | 'contactId'
        | 'serviceIds'
        | 'adminIds'
        | 'users'
        | 'startsOn'
        | 'projectClassId',
      value: any,
      shouldValidate?: boolean | undefined,
    ): void;
    (field: string, value: any): void;
  };
  setModalMode?: React.Dispatch<React.SetStateAction<'new' | 'edit'>>;
  setContactToEdit?: React.Dispatch<React.SetStateAction<Contact | undefined>>;
};

const selectorWithProps = () => {
  return (state: RootState) => {
    const { billingContact, subscription } = state.organization;

    // See https://github.com/globis-org/glopla-dev-portal/issues/79#issuecomment-415255884
    const sb = subscription.item;
    const rawContacts = billingContact.items;
    const contacts =
      sb && sb.billingContact
        ? uniqBy([...rawContacts, sb.billingContact], 'id')
        : rawContacts;

    const isContactExist = contacts.length !== 0;

    return {
      contacts,
      isContactExist,
    };
  };
};

export const BillingContactContainer: React.FC<Props> = (props) => {
  const { contacts, isContactExist } = useSelector(selectorWithProps());
  const childProps = { ...props, contacts, isContactExist };
  return <ContactView {...childProps} />;
};
